import ApiClientInstance from '../../common/ApiClient';

export const apiGetXeroBankAccounts = (companyId) => ApiClientInstance.get(`api/accountants/company/xero-bank-accounts${companyId ? `?company_id=${companyId}` : ''}`, undefined, true);

export const apiGetXeroBankAccountCodes = (companyId, xeroAccountId) => ApiClientInstance.get(`api/accountants/company/xero-bank-accounts/${xeroAccountId}/account-codes${companyId ? `?company_id=${companyId}` : ''}`, undefined, true);

export const apiGetXeroBankAccountMappings = (companyId, xeroAccountId) => ApiClientInstance.get(`api/accountants/company/xero-bank-accounts/${xeroAccountId}/categories-to-accounts${companyId ? `?company_id=${companyId}` : ''}`, undefined, true);

export const apiPutXeroBankAccountMappings = (companyId, xeroAccountId, items) => ApiClientInstance.put(`api/accountants/company/xero-bank-accounts/${xeroAccountId}/categories-to-accounts${companyId ? `?company_id=${companyId}` : ''}`, {
  items,
}, undefined, true);
